export default "__VITE_ASSET__436e700f__"